module.exports = __webpack_public_path__ + "img/fleet.9638caa1.jpg";